import { restRequest } from 'plugins/request';
import { ArticleResponseType } from 'types/api/articleResponseType';
import { QUERY_KEY_ARTICLES } from './index';
import useDeviceSize from 'utils/hooks/useDeviseSize';

export { QUERY_KEY_ARTICLES };

export const articles = restRequest(QUERY_KEY_ARTICLES);

// Types
export type ArticleShortData = {
  image?: string;
  title?: string | null;
  slug?: string;
  translation?: object;
  columnistId?: number;
  idCompany?: number;
  idBrand?: number;
  modulId?: number;
  category?: number;
  topSale?: number;
  status_id?: number;
  author_id?: number;
  page?: number;
  limit?: number;
};

export type ArticlesArr = Array<ArticleShortData>;

export type ArticlesData = [dataArr: ArticlesArr, totalCount: number];

export const apiGetArticles = async (
  params: ArticleShortData,
  locale: string | undefined,
  modulId?: number
): Promise<{ items: ArticleResponseType[] }> => {
  const { category, limit, topSale, ...otherParams } = params;

  return await articles.get('', false, false, {
    ...otherParams,
    lang: `${locale}`,
    modul_id: modulId,
    content: '',
    expand: 'categoriesByLang, slugs',
    userProfile: '',
    sort: '',
    top_sale: topSale || 0,
    status_id: 1,
    limit: 6,
    translationData: 'title,image,sub_title,views_count',
  });
};
